export default __webpack_public_path__ + "images/loggedout/thank-you-page/thank-you-image-f99bf321447d2809723d9a29fe98e9c0.png";